<section id="navmenu" class="side-menu" [class.collapsed]="isMenuCollapsed">
  <button tuiButton size="m" appearance="secondary" type="button" (click)="toggleMenu()" class="collapse-button" >
    <tui-icon icon="../assets/menu.svg"></tui-icon>
  </button>

  <div class="menu-header">
    <img src="assets/favicon.png" alt="logo" class="menu-header_logo" />
    <span class="menu-header_title"
      >Учет нуждающихся<br />в улучшении жилищных условий<br />и предоставлении земельных
      участков</span
    >
  </div>

  <ng-container *ngIf="!isMenuCollapsed">
    @for (navigation_item of navigationHierarchy; track navigation_item.id) {
      <ng-container
        *ngTemplateOutlet="menuItemOpened; context: { navigation_item: navigation_item, level: 0 }"
      ></ng-container>
    }
  </ng-container>

  <ng-container *ngIf="isMenuCollapsed">
    @for (navigation_item of navigationHierarchy; track navigation_item.id) {
      <ng-container
        *ngTemplateOutlet="closedMenu; context: { navigation_item: navigation_item }"
      ></ng-container>
    }
  </ng-container>

  <div class="build-version-content">
    <span
      [tuiHint]="versionHint"
      [tuiHintAppearance]="versionHintAppearance"
      [tuiHintDirection]="versionHintDirection"
    >
      Версия: {{ version }}
    </span>
  </div>
</section>

<!-- TODO: вынести в отдельный компонент -->
<section class="main">
  <router-outlet></router-outlet>
</section>

<ng-template #menuItemOpened let-level="level" let-navigation_item="navigation_item">
  <a
    (click)="
      navigation_item.children?.length === 0
        ? handleNavigation(navigation_item)
        : toggleItem(navigation_item)
    "
    [routerLink]="
      navigation_item.children?.length > 0 || isExternalLink(navigation_item.route)
        ? undefined
        : navigation_item.route
    "
    [routerLinkActive]="'active'"
    [class]="
      selectedSection === navigation_item.code ? 'menu-item menu-item_selected' : 'menu-item'
    "
    [style.padding-left.px]="level === 0 ? 0 : 44 + level * 20"
  >
    <tui-icon
      *ngIf="navigation_item.icon"
      [icon]="navigation_item.icon"
      size="s"
      class="menu-item__icon"
    ></tui-icon>
    <span *ngIf="!isMenuCollapsed" class="menu-item__title">
      {{ navigation_item.title }}
    </span>
  </a>
  <ng-container>
    @if (navigation_item.isExpanded && navigation_item.children?.length > 0) {
      @for (child of navigation_item.children; track child.id) {
        <ng-container
          *ngTemplateOutlet="menuItemOpened; context: { navigation_item: child, level: level + 1 }"
        ></ng-container>
      }
    }
  </ng-container>
</ng-template>

<ng-template #closedMenu let-navigation_item="navigation_item">
  <div
    class="collapsed-menu-content"
    (mouseleave)="setExpandedFalse(navigationHierarchy)"
    [id]="navigation_item.id"
  >
    <a
      (click)="navigation_item.children.length === 0 ? handleNavigation(navigation_item) : toggleItem(navigation_item)"
      [routerLinkActive]="'active'"
      [routerLink]="
    navigation_item.children.length > 0 || isExternalLink(navigation_item.route)
      ? undefined
      : navigation_item.route
  " (mouseenter)="toggleItem(navigation_item)"
      *ngIf="navigation_item.icon"
      class="menu-item menu-item__icon_closed"
    >
      <tui-icon
        *ngIf="navigation_item.icon"
                [icon]="navigation_item.icon"
                size="s"
                class="menu-item__icon">
      </tui-icon>
    </a>
    <ng-container
      *ngTemplateOutlet="
        menuClosedItem;
        context: { item: navigation_item, level: 1, topPadding: 0 }
      "
    >
    </ng-container>
  </div>
</ng-template>

<ng-template #menuClosedItem let-level="level" let-item="item" let-topPadding="topPadding">
  <div [id]="item.id">
    <div
      *ngIf="item.isExpanded && item.children.length > 0"
      class="side-menu__subitems"
      id="side-menu__subitems"
      [attr.data-parent-title]="item.title"
      [ngStyle]="{ left: level === 1 ? '45px' : '392px', top: topPadding * 40 + 'px' }"
    >
      <ng-container *ngFor="let navigation_item of item.children; let index = index">
        <a
          [ngClass]="
            selectedSection === navigation_item.code
              ? 'menu-item_selected side-menu__subitem'
              : 'side-menu__subitem'
          "
          (mouseenter)="navigation_item.children.length > 0 ? toggleItem(navigation_item) : hideOthers(navigation_item)"
          (click)="navigation_item.children.length === 0 ? handleNavigation(navigation_item) : toggleItem(navigation_item)"
          [routerLinkActive]="'active'"
          [routerLink]="
    navigation_item.children.length > 0 || isExternalLink(navigation_item.route)
      ? undefined
      : navigation_item.route
  "
        >
          <span
            class="side-menu__subitem-label"
            [ngStyle]="{ 'padding-left': level === 1 ? '64px' : '16px' }"
          >
            <tui-icon
              *ngIf="navigation_item.icon"
              [icon]="navigation_item.icon"
              size="s"
              class="side-menu__subitem-icon"
            ></tui-icon>
            <span>{{ navigation_item.title }}</span>
          </span>
          <span
            class="children-indicator"
            *ngIf="navigation_item.children?.length > 0"
          >
              &gt;
          </span>
        </a>
        <ng-container
          *ngTemplateOutlet="
            menuClosedItem;
            context: { item: navigation_item, level: level + 1, topPadding: index }
          "
        ></ng-container>
      </ng-container>
    </div>
  </div>
</ng-template>
